import { z } from "zod";
import { roleSchema } from "./role";

export const createInviteSchema = z.object({
  email: z.string().email().min(1),
  companyId: z.string().min(1),
  departmentIds: z.array(z.string().min(1)),
  role: roleSchema.exclude(["owner"]), // 'owner' should not be an option.
});
export type CreateInvite = z.infer<typeof createInviteSchema>;
